import React from "react";
import GameTypePickerModal from "./GameTypePickerModal";

function CreateRoomModal({
  closeCreateGame,
  user,
  onCreateRoom,
  gameTypes,

  gameType,
  requirePassword,
  setRequirePassword,
  roomPassword,
  setRoomPassword,

  setGameType,
  allowSpectators,
  setAllowSpectators,
}) {
  // Local state for room name, initialized from user profile
  const [showGameTypeModal, setShowGameTypeModal] = React.useState(false);
  const [localRoomName, setLocalRoomName] = React.useState(
    user?.roomName || ""
  );

  React.useEffect(() => {
    setLocalRoomName(user?.roomName || "");
  }, [user?.roomName]);

  // Preload game thumbnails when this modal is shown / mounted
  React.useEffect(() => {
    try {
      const arr = Array.isArray(gameTypes)
        ? gameTypes
        : Object.values(gameTypes || {});
      const urls = new Set();
      arr.forEach((t) => {
        if (t && t.thumbnail) urls.add(t.thumbnail);
      });
      const imgs = [];
      urls.forEach((u) => {
        try {
          const img = new Image();
          img.src = u;
          imgs.push(img);
        } catch (e) {}
      });

      return () => {
        // help GC by dereferencing
        imgs.forEach((i) => {
          try {
            i.src = "";
          } catch (e) {}
        });
      };
    } catch (err) {
      // ignore
    }
  }, [gameTypes]);

  // Set a random game type if not already selected
  React.useEffect(() => {
    if (
      (!gameType || !gameType.trim()) &&
      gameTypes &&
      ((Array.isArray(gameTypes) && gameTypes.length > 0) ||
        (typeof gameTypes === "object" && Object.keys(gameTypes).length > 0)) &&
      setGameType
    ) {
      const arr = Array.isArray(gameTypes)
        ? gameTypes
        : Object.values(gameTypes);
      const randomIdx = Math.floor(Math.random() * arr.length);
      const randomGame = arr[randomIdx];
      if (randomGame && randomGame.gameClass) {
        setGameType(randomGame.gameClass);
      }
    }
  }, [gameTypes, gameType, setGameType]);

  return (
    <div className="mb-4 w-full max-w-md mx-auto bg-gray-100 dark:bg-gray-800 p-4 rounded shadow flex flex-col gap-3">
      <div className="mb-2 w-full">
        <label
          htmlFor="roomNameInput"
          className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          Room Name
        </label>
        <input
          type="text"
          placeholder="Room Name"
          className="border p-2 mr-2 mb-0 w-full bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-700"
          value={localRoomName}
          onChange={(e) => setLocalRoomName(e.target.value)}
          id="roomNameInput"
          maxLength={20}
        />
      </div>
      <div className="mb-2">
        <label
          htmlFor="gameTypeInput"
          className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          Game Type
        </label>
        <button
          className="border p-2 w-full bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-700 rounded flex items-center justify-between"
          type="button"
          id="gameTypeInput"
          onClick={() => {
            //console.log('Select Game Type button clicked');
            setShowGameTypeModal(true);
          }}
        >
          <span>
            {(Array.isArray(gameTypes)
              ? gameTypes.find((gt) => gt.gameClass === gameType)
              : Object.values(gameTypes || {}).find(
                  (gt) => gt.gameClass === gameType
                )
            )?.displayName || "Select Game Type"}
          </span>
          <span className="text-xs text-gray-500">Change</span>
        </button>
        {showGameTypeModal && (
          <GameTypePickerModal
            showGameTypePicker={showGameTypeModal}
            closeGameTypePicker={() => setShowGameTypeModal(false)}
            onSelect={(key) => {
              setGameType(key);
              setShowGameTypeModal(false);
            }}
            selectedKey={gameType}
            mode="grid"
            gameTypes={gameTypes}
            title="Select Game Type"
          />
        )}
      </div>
      <div className="flex items-center mb-2">
        <input
          type="checkbox"
          id="allowSpectators"
          className="mr-2"
          checked={!!allowSpectators}
          onChange={(e) => setAllowSpectators(e.target.checked)}
        />
        <label htmlFor="allowSpectators">Allow Spectators</label>
      </div>
      <div className="flex items-center mb-2">
        <input
          type="checkbox"
          id="requirePassword"
          className="mr-2"
          checked={requirePassword}
          onChange={(e) => setRequirePassword(e.target.checked)}
        />
        <label htmlFor="requirePassword">Require Password</label>
      </div>

      {requirePassword && (
        <input
          type="password"
          placeholder="Enter password"
          className="border p-2 mb-2 w-full bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-700"
          value={roomPassword}
          onChange={(e) => setRoomPassword(e.target.value)}
        />
      )}
      <div className="flex gap-2 mt-2">
        <button
          className="bg-gray-400 text-white p-2 rounded w-full dark:bg-gray-700 dark:text-white hover:bg-gray-700 hover:dark:bg-gray-600"
          onClick={closeCreateGame}
          type="button"
        >
          Cancel
        </button>
        <button
          className="bg-green-500 text-white p-2 rounded w-full dark:bg-green-600 dark:text-white hover:bg-green-700 hover:dark:bg-green-700"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'auto' });
            onCreateRoom({ roomName: localRoomName });
          }}
          disabled={!localRoomName || !localRoomName.trim()}
          style={
            !localRoomName || !localRoomName.trim()
              ? { opacity: 0.6, cursor: "not-allowed" }
              : {}
          }
        >
          Create
        </button>
      </div>
    </div>
  );
}

export default CreateRoomModal;
